<template>
  <div>
    <div class="block level is-mobile">
      <div class="level-item has-text-centered">
        <div @click="$emit('abilityClicked', 'str')">
          <p class="title is-3">{{ plusOrMinus(abilities.str) }}</p>
          <p class="heading">
            STR
            <span v-if="characterClass.savingThrows.includes('str')">✦</span>
          </p>
        </div>
      </div>
      <div class="level-item has-text-centered">
        <div @click="$emit('abilityClicked', 'dex')">
          <p class="title is-3">{{ plusOrMinus(abilities.dex) }}</p>
          <p class="heading">
            DEX
            <span v-if="characterClass.savingThrows.includes('dex')">✦</span>
          </p>
        </div>
      </div>
      <div class="level-item has-text-centered">
        <div @click="$emit('abilityClicked', 'con')">
          <p class="title is-3">{{ plusOrMinus(abilities.con) }}</p>
          <p class="heading">
            CON
            <span v-if="characterClass.savingThrows.includes('con')">✦</span>
          </p>
        </div>
      </div>
    </div>  
    <div class="block level is-mobile">
      <div class="level-item has-text-centered">
        <div @click="$emit('abilityClicked', 'int')">
          <p class="title is-3">{{ plusOrMinus(abilities.int) }}</p>
          <p class="heading">
            INT
            <span v-if="characterClass.savingThrows.includes('int')">✦</span>
          </p>
        </div>
      </div>
      <div class="level-item has-text-centered">
        <div @click="$emit('abilityClicked', 'wis')">
          <p class="title is-3">{{ plusOrMinus(abilities.wis) }}</p>
          <p class="heading">
            WIS
            <span v-if="characterClass.savingThrows.includes('wis')">✦</span>
          </p>
        </div>
      </div>
      <div class="level-item has-text-centered">
        <div @click="$emit('abilityClicked', 'cha')">
          <p class="title is-3">{{ plusOrMinus(abilities.cha) }}</p>
          <p class="heading">
            CHA
            <span v-if="characterClass.savingThrows.includes('cha')">✦</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, inject } from 'vue'

import plusOrMinus from '@/helpers/plusOrMinus'

export default defineComponent({
  setup () {
    const computedCharacter = inject('computedCharacter')

    return {
      plusOrMinus,
      ...computedCharacter
    }
  }
})
</script>

<style lang="sass" scoped>
.title
  margin-bottom: 0.5rem !important
  font-family: 'Playfair Display', serif

.heading
  margin-bottom: 0 !important
  font-weight: bold
  font-family: 'Roboto', sans-serif

.level-item
  flex: 1
  > div:hover
    position: relative
    cursor: pointer
    > *
      position: relative
    &::before
      content: ''
      display: block
      width: 4rem
      height: 4rem
      position: absolute
      top: 55%
      left: 50%
      opacity: 0.05
      transform: translate(-50%, -50%)
      background: #000
      border-radius: 50%
</style>
